import { useSelector } from "react-redux";
import AccountRepository from "src/repository/Admin/AccountRepository";
import { getAccountList, getAccountDetail, getAccountUserList, setAccountList, setAccountListMessage, setAccountUserListMessage } from "src/store/slice/model/Admin/Account";
import store from "src/storeWire";


export function useAccountStore() {
    const accountList = useSelector((state) => state.entities.model_Admin_Account_list.accountList)
    const totalRecords = useSelector((state) => state.entities.model_Admin_Account_list.totalRecords)
    const filteredRecords = useSelector((state) => state.entities.model_Admin_Account_list.filteredRecords)
    const accountListMessage = useSelector((state) => state.entities.model_Admin_Account_list.accountListMessage)
    const accountDetail = useSelector((state) => state.entities.model_Admin_Account_list.accountDetail)
    const accountUserList = useSelector((state) => state.entities.model_Admin_Account_list.accountUserList)
    const totalAccountUser = useSelector((state) => state.entities.model_Admin_Account_list.totalAccountUser)
    const filteredAccountUsers = useSelector((state) => state.entities.model_Admin_Account_list.filteredAccountUsers)
    const accountUserListMessage = useSelector((state) => state.entities.model_Admin_Account_list.accountUserListMessage)

    let data = {
        accountList,
        totalRecords,
        filteredRecords,
        accountListMessage,
        accountDetail,
        accountUserList,
        totalAccountUser,
        filteredAccountUsers,
        accountUserListMessage
    };

    let fetch = {
        get_account_list: async (params) => {
            return await store.dispatch(getAccountList(params))
        },
        get_account_detail: async (accountId) => {
            return await store.dispatch(getAccountDetail(accountId))
        },
        get_account_user_list: async (params) => {
            return await store.dispatch(getAccountUserList(params))
        },

        get_account_export: async (params) => {
            return await new AccountRepository().getAccountExport(params);
        },
        export_account_user_list: async (params) => {
            return await new AccountRepository().exportAccountUsrList(params);
        },
        email_accouts: async (params) => {
            return await new AccountRepository().emailAccounts(params);
        },
        email_account_user_list: async (params) => {
            return await new AccountRepository().emailAccountUserList(params);
        }
    };
    let set = {
        set_account_list: () => {
            return store.dispatch(setAccountList([]));
        },
        set_account_list_message: (message) => {
            return store.dispatch(setAccountListMessage(message));
        },
        set_account_user_list_message: (message) => {
            return store.dispatch(setAccountUserListMessage(message));
        },

        update_unsponsor_acct_by_user: async (params) => {
            return await new AccountRepository().updateUnsponsorAcctByUser(params);
        },
    };
    return [data, fetch, set]
}
